import React from 'react';
var ArrowLeft = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'none' : _b, _c = _a.className, className = _c === void 0 ? 'h-3 w-3' : _c;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "256", height: "256", viewBox: "0 0 256 256", className: className, fill: fill },
        React.createElement("path", { fill: 'currentColor', strokeMiterlimit: "10", strokeWidth: "0", d: "M65.36 0L69.64 4.28 28.92 45 69.64 85.72 65.36 90 20.36 45z", transform: "matrix(2.81 0 0 2.81 1.407 1.407)" })));
};
export default ArrowLeft;
//# sourceMappingURL=arrow-left.js.map